module.exports = __webpack_public_path__ + "static/IBMPlexSans-Italic-9ef62df91e7b0f1ccccd5cfd1a018485.woff2";